import React from 'react';
import * as Icon from 'ubs-icons';
import UPopup from "ubs-framework/v2/UPopup";
import { COLOR } from '../../constant';
import { isMobileDevice } from '../../function';

const Action = React.memo((props) => {
    return (
        <div className="u_table-resource-action">
            <div className="u_cp u_table-resource-menu">
                <span className="u_more-menu-icon u_flex u_align-center u_content-end">
                    {props?.commentIcon && <UPopup
                        params={{className: "u_tooltip", disabled: isMobileDevice()}}
                        desc={<span>Conversation</span>}
                    >
                        <div className="u_unread u_mr-10">
                            <span className="u_unread-inner"/>
                            <span className={`u_icon-rollover u_cp u_ml-5`}>
                                <Icon.CommentFill fill={COLOR?.u_blue} size={16}/>
                            </span>
                        </div>
                    </UPopup>}
                    <Icon.HorizontalMenu size={20} fill={COLOR.u_icon_bg}/>
                </span>
            </div>
            <div className="u_table-resource-buttons">
                {props.children}
            </div>
        </div>
    );
});

export default Action;
